import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

const CONTACT = { email:"parmjeetgadwal@gmail.com", phone:"9588331323" };

const stats = [
  { value:"50,000+", label:"Leads Generated" },
  { value:"200+",    label:"Happy Clients" },
  { value:"30 Min",  label:"Auto Refresh" },
  { value:"6+",      label:"Data Sources" },
  { value:"35+",     label:"Business Types" },
];

const ALL_FEATURES = [
  {
    icon:"🔍", title:"Lead Search",
    desc:"Search any niche + city and get real businesses with phone numbers, addresses and ratings instantly.",
    free:true, freeLabel:"2 searches free",
    paid:"Unlimited searches",
    tag:"CORE",
  },
  {
    icon:"🗺️", title:"Google Maps Leads",
    desc:"Real businesses with verified phone numbers, star ratings, review counts and websites from Google Maps.",
    free:true, freeLabel:"5 leads free",
    paid:"Unlimited leads",
    tag:"CORE",
  },
  {
    icon:"📒", title:"JustDial & Sulekha",
    desc:"India's biggest local directories scraped in real time for any niche — restaurants, gyms, clinics and more.",
    free:false,
    paid:"All paid plans",
    tag:"SCRAPER",
  },
  {
    icon:"🏭", title:"IndiaMart Leads",
    desc:"B2B suppliers, manufacturers and wholesalers across India for any product category.",
    free:false,
    paid:"All paid plans",
    tag:"SCRAPER",
  },
  {
    icon:"🤖", title:"AI Lead Scoring",
    desc:"Every lead scored 0-100 by AI with Hot/Warm/Cold intent tags. Know who to call first.",
    free:true, freeLabel:"Included free",
    paid:"Included all plans",
    tag:"AI",
  },
  {
    icon:"📧", title:"Auto Email Delivery",
    desc:"Fresh leads delivered to your inbox every 30 minutes automatically. Never miss a prospect.",
    free:false,
    paid:"All paid plans",
    tag:"AUTOMATION",
  },
  {
    icon:"📋", title:"CRM Pipeline",
    desc:"Track every lead — New, Contacted, Interested, Follow Up, Converted. Built-in mini CRM.",
    free:true, freeLabel:"Included free",
    paid:"Included all plans",
    tag:"CRM",
  },
  {
    icon:"⬇", title:"CSV / Excel Export",
    desc:"Download all your leads as a CSV file. Import into any CRM, Excel or Google Sheets instantly.",
    free:false,
    paid:"All paid plans",
    tag:"EXPORT",
  },
  {
    icon:"🔄", title:"Duplicate Detection",
    desc:"Automatic deduplication by phone number and name. Never get the same lead twice.",
    free:true, freeLabel:"Included free",
    paid:"Included all plans",
    tag:"AI",
  },
  {
    icon:"⚡", title:"Auto Lead Generation",
    desc:"Set your niche + city once. System generates fresh leads every 30 minutes on autopilot.",
    free:false,
    paid:"All paid plans",
    tag:"AUTOMATION",
  },
  {
    icon:"🤖", title:"AI Chatbot",
    desc:"Ask the AI to find leads, suggest niches, explain features or answer any business question.",
    free:true, freeLabel:"Included free",
    paid:"Included all plans",
    tag:"AI",
  },
];

const plans = [
  {
    name:"Free", price:"0", color:"#6b7280", popular:false, amount:0,
    features:[
      { text:"2 lead searches",        check:true  },
      { text:"5 leads per search",      check:true  },
      { text:"Google Maps only",        check:true  },
      { text:"AI lead scoring",         check:true  },
      { text:"Duplicate detection",     check:true  },
      { text:"AI chatbot",              check:true  },
      { text:"JustDial / Sulekha",      check:false },
      { text:"Auto email delivery",     check:false },
      { text:"CRM pipeline",            check:true  },
      { text:"CSV export",              check:false },
    ],
    cta:"Start Free",
  },
  {
    name:"Starter", price:"999", color:"#00d4aa", popular:false, amount:99900,
    features:[
      { text:"500 leads / month",       check:true },
      { text:"Google Maps + JustDial",  check:true },
      { text:"Sulekha + IndiaMart",     check:true },
      { text:"AI scoring & intent tags",check:true },
      { text:"Auto email every 30 min", check:true },
      { text:"CRM pipeline",            check:true },
      { text:"CSV export",              check:true },
      { text:"Duplicate detection",     check:true },
      { text:"AI chatbot",              check:true },
      { text:"API access",              check:false },
    ],
    cta:"Get Starter",
  },
  {
    name:"Pro", price:"1,999", color:"#ff6b35", popular:true, amount:199900,
    features:[
      { text:"2000 leads / month",      check:true },
      { text:"All 6 platforms",         check:true },
      { text:"AI scoring & intent tags",check:true },
      { text:"Auto email every 30 min", check:true },
      { text:"CRM pipeline",            check:true },
      { text:"CSV export",              check:true },
      { text:"Duplicate detection",     check:true },
      { text:"AI chatbot",              check:true },
      { text:"Priority support",        check:true },
      { text:"API access",              check:false },
    ],
    cta:"Get Pro",
  },
  {
    name:"Enterprise", price:"3,999", color:"#a855f7", popular:false, amount:399900,
    features:[
      { text:"Unlimited leads",         check:true },
      { text:"All 6 platforms",         check:true },
      { text:"AI scoring & intent tags",check:true },
      { text:"Auto email every 30 min", check:true },
      { text:"CRM pipeline",            check:true },
      { text:"CSV export",              check:true },
      { text:"Duplicate detection",     check:true },
      { text:"AI chatbot",              check:true },
      { text:"API access",              check:true },
      { text:"24/7 dedicated support",  check:true },
    ],
    cta:"Get Enterprise",
  },
];

const TAG_COLOR = {
  CORE:"#00d4aa", AI:"#a855f7", SCRAPER:"#60a5fa",
  AUTOMATION:"#f59e0b", CRM:"#f87171", EXPORT:"#ff6b35",
};

export default function Landing() {
  const navigate = useNavigate();
  const [scrolled, setScrolled] = useState(false);
  const [activeTag, setActiveTag] = useState("ALL");

  useEffect(() => {
    const f = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", f);
    return () => window.removeEventListener("scroll", f);
  }, []);

  const tags = ["ALL","CORE","AI","SCRAPER","AUTOMATION","CRM","DELIVERY","EXPORT"];
  const shown = activeTag === "ALL" ? ALL_FEATURES : ALL_FEATURES.filter(f => f.tag === activeTag);

  return (
    <div style={{ fontFamily:"'DM Sans',sans-serif", background:"#050510", color:"#fff", overflowX:"hidden" }}>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;700&family=Syne:wght@700;800;900&display=swap" rel="stylesheet"/>
      <style>{`
        @keyframes float{0%,100%{transform:translateY(0)}50%{transform:translateY(-18px)}}
        @keyframes slideIn{from{opacity:0;transform:translateY(30px)}to{opacity:1;transform:translateY(0)}}
        .nav-link:hover{color:#00d4aa!important}
        .fcard:hover{transform:translateY(-6px);border-color:#00d4aa33!important}
        .pcard:hover{transform:translateY(-8px)}
        .btn-p:hover{transform:translateY(-2px);box-shadow:0 16px 40px rgba(0,212,170,0.3)!important}
        *{box-sizing:border-box}
      `}</style>

      {/* Navbar */}
      <nav style={{ position:"fixed",top:0,left:0,right:0,zIndex:100,padding:"16px 40px",background:scrolled?"rgba(5,5,16,0.96)":"transparent",backdropFilter:scrolled?"blur(20px)":"none",borderBottom:scrolled?"1px solid #ffffff11":"none",transition:"all 0.3s",display:"flex",alignItems:"center",justifyContent:"space-between" }}>
        <div style={{ fontFamily:"'Syne',sans-serif",fontWeight:900,fontSize:22,color:"#00d4aa" }}>⚡ LeadBot Pro</div>
        <div style={{ display:"flex",gap:24,alignItems:"center" }}>
          {[["features","Features"],["pricing","Pricing"],["compare","Compare"],["contact","Contact"]].map(([id,label]) => (
            <a key={id} href={"#"+id} className="nav-link" style={{ color:"#9ca3af",fontSize:14,textDecoration:"none",transition:"color 0.2s" }}>{label}</a>
          ))}
          <button onClick={() => navigate("/login")} style={{ background:"transparent",color:"#9ca3af",border:"1px solid #ffffff22",borderRadius:8,padding:"9px 18px",fontFamily:"'DM Sans',sans-serif",fontSize:14,cursor:"pointer" }}>Login</button>
          <button onClick={() => navigate("/admin")} style={{ background:"transparent",color:"#6b7280",border:"1px solid #ffffff11",borderRadius:8,padding:"9px 18px",fontFamily:"'DM Sans',sans-serif",fontSize:13,cursor:"pointer" }}>Admin</button>
          <button onClick={() => navigate("/signup")} style={{ background:"#00d4aa",color:"#050510",border:"none",borderRadius:8,padding:"10px 20px",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:14,cursor:"pointer" }}>Get Started Free</button>
        </div>
      </nav>

      {/* Hero */}
      <section style={{ minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",position:"relative",padding:"120px 40px 80px",textAlign:"center" }}>
        <div style={{ position:"absolute",top:"15%",left:"5%",width:500,height:500,background:"radial-gradient(circle,#00d4aa15,transparent)",borderRadius:"50%",animation:"float 6s ease-in-out infinite",pointerEvents:"none" }}/>
        <div style={{ position:"absolute",bottom:"10%",right:"5%",width:400,height:400,background:"radial-gradient(circle,#a855f715,transparent)",borderRadius:"50%",animation:"float 8s ease-in-out infinite reverse",pointerEvents:"none" }}/>
        <div style={{ maxWidth:900,animation:"slideIn 0.8s ease",position:"relative",zIndex:1 }}>
          <div style={{ display:"inline-flex",alignItems:"center",gap:8,background:"#00d4aa18",border:"1px solid #00d4aa44",borderRadius:20,padding:"7px 18px",fontSize:13,color:"#00d4aa",marginBottom:28 }}>
            <span style={{ width:6,height:6,borderRadius:"50%",background:"#00d4aa",display:"inline-block",boxShadow:"0 0 8px #00d4aa" }}/>
            🚀 India's Most Advanced AI Lead Generation Platform
          </div>
          <h1 style={{ fontFamily:"'Syne',sans-serif",fontSize:"clamp(36px,6vw,72px)",fontWeight:900,lineHeight:1.1,margin:"0 0 24px" }}>
            Get Qualified Business<br/>
            <span style={{ background:"linear-gradient(135deg,#00d4aa,#a855f7)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent" }}>Leads on Autopilot</span>
          </h1>
          <p style={{ fontSize:18,color:"#9ca3af",lineHeight:1.7,maxWidth:640,margin:"0 auto 32px" }}>
            Real leads from Google Maps, JustDial, IndiaMart, Sulekha, LinkedIn & Naukri with phone numbers — AI scored, auto-delivered every 30 minutes.
          </p>

          {/* Free vs Paid pills */}
          <div style={{ display:"flex",gap:10,justifyContent:"center",flexWrap:"wrap",marginBottom:36 }}>
            {[
              { label:"✅ Free: 2 searches + CRM", color:"#00d4aa" },
            { label:"⚡ Paid: Customer Finder B2C mode", color:"#a855f7" },
              { label:"🔒 Paid: Auto delivery + CRM + CSV export", color:"#f59e0b" },
              { label:"🔒 Paid: Unlimited leads + CSV export", color:"#a855f7" },
            ].map((p,i) => (
              <span key={i} style={{ background:p.color+"15",border:"1px solid "+p.color+"44",borderRadius:20,padding:"6px 16px",fontSize:13,color:p.color,fontWeight:600 }}>{p.label}</span>
            ))}
          </div>

          <div style={{ display:"flex",gap:14,justifyContent:"center",flexWrap:"wrap",marginBottom:56 }}>
            <button className="btn-p" onClick={() => navigate("/signup")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)",color:"#050510",border:"none",borderRadius:12,padding:"16px 36px",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:17,cursor:"pointer",transition:"all 0.3s" }}>
              🎯 Try Free — No Card Required
            </button>
            <button onClick={() => document.getElementById("pricing").scrollIntoView({behavior:"smooth"})} style={{ background:"transparent",color:"#fff",border:"1px solid #ffffff33",borderRadius:12,padding:"16px 28px",fontFamily:"'DM Sans',sans-serif",fontSize:16,cursor:"pointer" }}>
              View Pricing →
            </button>
          </div>

          <div style={{ display:"flex",gap:40,justifyContent:"center",flexWrap:"wrap" }}>
            {stats.map((s,i) => (
              <div key={i}>
                <div style={{ fontFamily:"'Syne',sans-serif",fontSize:30,fontWeight:900,color:"#00d4aa" }}>{s.value}</div>
                <div style={{ fontSize:13,color:"#6b7280" }}>{s.label}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* All Features Section */}
      <section id="features" style={{ padding:"100px 40px",maxWidth:1300,margin:"0 auto" }}>
        <div style={{ textAlign:"center",marginBottom:20 }}>
          <h2 style={{ fontFamily:"'Syne',sans-serif",fontSize:48,fontWeight:900,marginBottom:14 }}>Every Feature. <span style={{ color:"#00d4aa" }}>Zero Confusion.</span></h2>
          <p style={{ color:"#9ca3af",fontSize:18,marginBottom:32 }}>See exactly what's free and what requires a plan — no surprises.</p>
          {/* Tag filter */}
          <div style={{ display:"flex",gap:8,justifyContent:"center",flexWrap:"wrap",marginBottom:48 }}>
            {tags.map(t => (
              <button key={t} onClick={() => setActiveTag(t)} style={{ background: activeTag===t?(TAG_COLOR[t]||"#00d4aa")+"22":"transparent", color: activeTag===t?(TAG_COLOR[t]||"#00d4aa"):"#6b7280", border:"1px solid "+(activeTag===t?(TAG_COLOR[t]||"#00d4aa")+"44":"#ffffff11"), borderRadius:20, padding:"7px 18px", fontSize:12, cursor:"pointer", fontFamily:"'DM Sans',sans-serif", fontWeight:700, transition:"all 0.2s" }}>
                {t}
              </button>
            ))}
          </div>
        </div>

        <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:16 }}>
          {shown.map((f,i) => (
            <div key={i} className="fcard" style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)",border:"1px solid #ffffff0d",borderRadius:20,padding:28,transition:"all 0.3s",position:"relative",overflow:"hidden" }}>
              {/* Tag */}
              <div style={{ position:"absolute",top:16,right:16,background:(TAG_COLOR[f.tag]||"#00d4aa")+"22",color:TAG_COLOR[f.tag]||"#00d4aa",border:"1px solid "+(TAG_COLOR[f.tag]||"#00d4aa")+"44",borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700 }}>{f.tag}</div>
              <div style={{ fontSize:36,marginBottom:14 }}>{f.icon}</div>
              <h3 style={{ fontFamily:"'Syne',sans-serif",fontSize:18,fontWeight:900,marginBottom:8 }}>{f.title}</h3>
              <p style={{ color:"#9ca3af",fontSize:14,lineHeight:1.6,marginBottom:16 }}>{f.desc}</p>
              {/* Free / Paid badge */}
              <div style={{ display:"flex",gap:8,flexWrap:"wrap" }}>
                {f.free ? (
                  <span style={{ background:"#00d4aa18",color:"#00d4aa",border:"1px solid #00d4aa44",borderRadius:8,padding:"4px 12px",fontSize:12,fontWeight:700 }}>
                    ✅ FREE — {f.freeLabel}
                  </span>
                ) : (
                  <span style={{ background:"#f59e0b18",color:"#f59e0b",border:"1px solid #f59e0b44",borderRadius:8,padding:"4px 12px",fontSize:12,fontWeight:700 }}>
                    🔒 {f.paid}
                  </span>
                )}
                {f.free && f.paid && (
                  <span style={{ background:"#a855f718",color:"#a855f7",border:"1px solid #a855f744",borderRadius:8,padding:"4px 12px",fontSize:12,fontWeight:700 }}>
                    ⚡ {f.paid} (more)
                  </span>
                )}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Free vs Paid Comparison */}
      <section id="compare" style={{ padding:"80px 40px",maxWidth:900,margin:"0 auto" }}>
        <div style={{ textAlign:"center",marginBottom:48 }}>
          <h2 style={{ fontFamily:"'Syne',sans-serif",fontSize:42,fontWeight:900,marginBottom:12 }}>Free vs <span style={{ color:"#00d4aa" }}>Paid</span></h2>
          <p style={{ color:"#9ca3af",fontSize:17 }}>Exactly what you get on each tier — no fine print</p>
        </div>
        <div style={{ background:"#0d0d1f",border:"1px solid #ffffff0d",borderRadius:24,overflow:"hidden" }}>
          <div style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",background:"#ffffff08",padding:"16px 24px" }}>
            <div style={{ color:"#9ca3af",fontSize:12,textTransform:"uppercase",letterSpacing:1 }}>Feature</div>
            <div style={{ color:"#00d4aa",fontSize:13,fontWeight:700,textAlign:"center" }}>✅ Free</div>
            <div style={{ color:"#f59e0b",fontSize:13,fontWeight:700,textAlign:"center" }}>⚡ Any Paid Plan</div>
          </div>
          {[
            ["Lead Search",              "2 searches",          "Unlimited"],
            ["Leads per search",         "5 leads",             "20-50+ leads"],
            ["Google Maps",              "✓",                   "✓"],
            ["JustDial + Sulekha",        "✗",                   "✓"],
            ["IndiaMart",                "✗",                   "✓"],
            ["AI Lead Scoring",          "✓",                   "✓"],
            ["Duplicate Detection",      "✓",                   "✓"],
            ["AI Chatbot",               "✓",                   "✓"],
            ["Auto Email Delivery",      "✗",                   "✓ Every 30 min"],
            ["CRM Pipeline",             "✓",                   "✓ Advanced"],
            ["CSV Export",               "✗",                   "✓"],
            ["API Access",               "✗",                   "✓ Enterprise"],
            ["Auto Lead Generation",     "✗",                   "✓ Every 30 min"],
          ].map(([feat, free, paid], i) => (
            <div key={i} style={{ display:"grid",gridTemplateColumns:"2fr 1fr 1fr",padding:"14px 24px",borderTop:"1px solid #ffffff08",alignItems:"center" }}>
              <div style={{ fontSize:14,color:"#d1d5db" }}>{feat}</div>
              <div style={{ textAlign:"center",fontSize:13,color: free==="✓"||free.startsWith("✓")?"#00d4aa":free==="✗"?"#f87171":"#9ca3af",fontWeight:600 }}>{free}</div>
              <div style={{ textAlign:"center",fontSize:13,color: paid==="✗"?"#f87171":"#00d4aa",fontWeight:600 }}>{paid}</div>
            </div>
          ))}
        </div>
        <div style={{ textAlign:"center",marginTop:32 }}>
          <button onClick={() => navigate("/signup")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)",color:"#050510",border:"none",borderRadius:12,padding:"14px 36px",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:16,cursor:"pointer" }}>
            Start Free — Upgrade Anytime →
          </button>
        </div>
      </section>

      {/* How it works */}
      <section style={{ padding:"80px 40px",maxWidth:1000,margin:"0 auto",textAlign:"center" }}>
        <h2 style={{ fontFamily:"'Syne',sans-serif",fontSize:42,fontWeight:900,marginBottom:48 }}>How It <span style={{ color:"#00d4aa" }}>Works</span></h2>
        <div style={{ display:"grid",gridTemplateColumns:"repeat(auto-fit,minmax(200px,1fr))",gap:20 }}>
          {[
            { step:"1", icon:"✉",  title:"Sign Up Free",    desc:"Create account in 30 seconds. No credit card needed.",       free:true  },
            { step:"2", icon:"🔍", title:"Search Leads",    desc:"Pick niche + city. Get 2 free searches with real leads.",      free:true  },
            { step:"3", icon:"🤖", title:"AI Scores Leads", desc:"Every lead scored 0-100 with Hot/Warm/Cold intent tags.",      free:true  },
            { step:"4", icon:"🚀", title:"Upgrade for More",desc:"Unlock unlimited leads, CRM, CSV export and auto-delivery.",free:false },
            { step:"5", icon:"⚡", title:"Auto Delivery",   desc:"Leads auto-generated and emailed every 30 minutes.",           free:false },
          ].map((s,i) => (
            <div key={i} style={{ background:"#0d0d1f",border:"1px solid "+(s.free?"#00d4aa22":"#f59e0b22"),borderRadius:16,padding:24,position:"relative" }}>
              <div style={{ position:"absolute",top:12,right:12,background:s.free?"#00d4aa18":"#f59e0b18",color:s.free?"#00d4aa":"#f59e0b",border:"1px solid "+(s.free?"#00d4aa44":"#f59e0b44"),borderRadius:6,padding:"2px 8px",fontSize:10,fontWeight:700 }}>{s.free?"FREE":"PAID"}</div>
              <div style={{ width:44,height:44,borderRadius:12,background:"#00d4aa22",border:"1px solid #00d4aa44",display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"'Syne',sans-serif",fontWeight:900,color:"#00d4aa",fontSize:18,margin:"0 auto 16px" }}>{s.step}</div>
              <div style={{ fontSize:28,marginBottom:10 }}>{s.icon}</div>
              <h3 style={{ fontFamily:"'Syne',sans-serif",fontSize:16,marginBottom:8 }}>{s.title}</h3>
              <p style={{ color:"#9ca3af",fontSize:13,lineHeight:1.6 }}>{s.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Free CTA */}
      <section style={{ padding:"60px 40px" }}>
        <div style={{ maxWidth:860,margin:"0 auto",background:"linear-gradient(135deg,#00d4aa12,#a855f712)",border:"1px solid #00d4aa33",borderRadius:24,padding:48,textAlign:"center" }}>
          <div style={{ fontSize:48,marginBottom:16 }}>🎁</div>
          <h2 style={{ fontFamily:"'Syne',sans-serif",fontSize:36,fontWeight:900,marginBottom:14 }}>Try Before You Buy</h2>
          <p style={{ color:"#9ca3af",fontSize:17,maxWidth:500,margin:"0 auto 16px" }}>2 free searches · Real phone numbers · AI scoring · No credit card</p>
          <div style={{ display:"flex",gap:12,justifyContent:"center",flexWrap:"wrap",marginBottom:32 }}>
            {["✅ 2 free searches","✅ Real phone numbers","✅ AI scoring","✅ No credit card"].map((t,i) => (
              <span key={i} style={{ background:"#00d4aa18",border:"1px solid #00d4aa33",borderRadius:20,padding:"5px 14px",fontSize:13,color:"#00d4aa",fontWeight:600 }}>{t}</span>
            ))}
          </div>
          <button onClick={() => navigate("/signup")} style={{ background:"linear-gradient(135deg,#00d4aa,#00b894)",color:"#050510",border:"none",borderRadius:12,padding:"16px 44px",fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:18,cursor:"pointer" }}>
            Claim My 2 Free Leads →
          </button>
        </div>
      </section>

      {/* Pricing */}
      
      {/* Customer Finder Highlight */}
      <section style={{ padding:"80px 40px", background:"linear-gradient(135deg,#0a0a1f,#050510)" }}>
        <div style={{ maxWidth:1100, margin:"0 auto" }}>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:48, alignItems:"center" }}>
            <div>
              <div style={{ display:"inline-block", background:"#a855f722", border:"1px solid #a855f744", borderRadius:20, padding:"5px 16px", fontSize:13, color:"#a855f7", fontWeight:700, marginBottom:16 }}>🎯 NEW FEATURE</div>
              <h2 style={{ fontFamily:"'Syne',sans-serif", fontSize:40, fontWeight:900, marginBottom:16, lineHeight:1.2 }}>
                Customer Finder<br/><span style={{ color:"#a855f7" }}>For Any Business</span>
              </h2>
              <p style={{ color:"#9ca3af", fontSize:17, lineHeight:1.7, marginBottom:24 }}>
                Not just B2B leads — find <strong style={{color:"#fff"}}>individual customers</strong> for your specific business.
                Bus company, hospital, gym, restaurant, insurance agent — we find YOUR customers from 6 platforms.
              </p>
              <div style={{ display:"flex", flexDirection:"column", gap:12, marginBottom:28 }}>
                {[
                  { icon:"🚌", text:"Bus company → Find corporate offices, schools, hotels needing transport" },
                  { icon:"🏥", text:"Hospital → Find senior citizen clubs, patient communities, insurance firms" },
                  { icon:"💪", text:"Gym → Find IT companies for corporate wellness, housing societies" },
                  { icon:"🎓", text:"Coaching → Find schools, colleges, student hostels nearby" },
                  { icon:"💍", text:"Wedding planner → Find jewellery shops, banquet halls, engaged couples" },
                  { icon:"🛡️", text:"Insurance → Find car dealers, new flat buyers, young professionals" },
                ].map((item,i) => (
                  <div key={i} style={{ display:"flex", alignItems:"flex-start", gap:12, fontSize:14, color:"#9ca3af" }}>
                    <span style={{ fontSize:20, flexShrink:0 }}>{item.icon}</span>
                    <span>{item.text}</span>
                  </div>
                ))}
              </div>
              <button onClick={() => window.location.href="/signup"} style={{ background:"linear-gradient(135deg,#a855f7,#7c3aed)", color:"#fff", border:"none", borderRadius:12, padding:"14px 32px", fontFamily:"'DM Sans',sans-serif", fontWeight:700, fontSize:16, cursor:"pointer" }}>
                🎯 Try Customer Finder Free →
              </button>
            </div>
            <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
              {[
                { icon:"🚌", title:"Transport", desc:"Corporate, hotels, schools", color:"#4285f4" },
                { icon:"🏥", title:"Healthcare", desc:"Patients, senior citizens", color:"#00d4aa" },
                { icon:"🎓", title:"Education", desc:"Students, parents, colleges", color:"#f59e0b" },
                { icon:"💰", title:"Finance", desc:"Home buyers, vehicle owners", color:"#ff6b35" },
                { icon:"🏠", title:"Real Estate", desc:"New owners, renovators", color:"#a855f7" },
                { icon:"🎪", title:"Events", desc:"Couples, corporates, societies", color:"#f87171" },
                { icon:"🏭", title:"Industrial", desc:"Manufacturers, factories", color:"#06b6d4" },
                { icon:"🛍️", title:"Retail", desc:"Restaurants, hotels, salons", color:"#10b981" },
              ].map((c,i) => (
                <div key={i} style={{ background:"#0d0d1f", border:"1px solid "+c.color+"33", borderRadius:14, padding:16, textAlign:"center" }}>
                  <div style={{ fontSize:28, marginBottom:6 }}>{c.icon}</div>
                  <div style={{ fontFamily:"'Syne',sans-serif", fontWeight:700, fontSize:13, color:c.color, marginBottom:3 }}>{c.title}</div>
                  <div style={{ color:"#6b7280", fontSize:11 }}>{c.desc}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>


      <section id="pricing" style={{ padding:"100px 40px" }}>
        <div style={{ textAlign:"center",marginBottom:60 }}>
          <h2 style={{ fontFamily:"'Syne',sans-serif",fontSize:48,fontWeight:900,marginBottom:14 }}>Simple <span style={{ color:"#00d4aa" }}>Pricing</span></h2>
          <p style={{ color:"#9ca3af",fontSize:18 }}>Start free. Upgrade when ready. Cancel anytime.</p>
        </div>
        <div style={{ display:"flex",gap:16,justifyContent:"center",flexWrap:"wrap",maxWidth:1200,margin:"0 auto" }}>
          {plans.map((plan,i) => (
            <div key={i} className="pcard" style={{ background:"linear-gradient(135deg,#0d0d1f,#111128)",border:plan.popular?"2px solid "+plan.color:"1px solid #ffffff0d",borderRadius:24,padding:32,width:270,position:"relative",transition:"all 0.3s",flexShrink:0 }}>
              {plan.popular && <div style={{ position:"absolute",top:-13,left:"50%",transform:"translateX(-50%)",background:plan.color,color:"#050510",borderRadius:20,padding:"4px 16px",fontSize:11,fontWeight:700,whiteSpace:"nowrap" }}>MOST POPULAR</div>}
              <div style={{ color:plan.color,fontSize:13,fontWeight:700,marginBottom:6,textTransform:"uppercase",letterSpacing:1 }}>{plan.name}</div>
              <div style={{ fontFamily:"'Syne',sans-serif",fontSize:46,fontWeight:900,marginBottom:2 }}>{plan.price==="0"?"Free":"₹"+plan.price}</div>
              {plan.price!=="0" && <div style={{ color:"#9ca3af",fontSize:13,marginBottom:20 }}>/month</div>}
              {plan.price==="0" && <div style={{ color:"#9ca3af",fontSize:13,marginBottom:20 }}>forever</div>}
              <div style={{ borderTop:"1px solid #ffffff0d",paddingTop:20,marginBottom:24 }}>
                {plan.features.map((f,j) => (
                  <div key={j} style={{ display:"flex",alignItems:"center",gap:10,marginBottom:9,fontSize:13,color:f.check?"#d1d5db":"#4b5563" }}>
                    <span style={{ color:f.check?plan.color:"#4b5563",flexShrink:0,fontSize:14 }}>{f.check?"✓":"✗"}</span>
                    {f.text}
                  </div>
                ))}
              </div>
              <button onClick={() => navigate(plan.price==="0"?"/signup":"/signup")} style={{ width:"100%",background:plan.popular?plan.color:plan.price==="0"?"#ffffff11":"transparent",color:plan.popular?"#050510":plan.price==="0"?"#fff":plan.color,border:"1px solid "+(plan.popular?plan.color:plan.price==="0"?"#ffffff22":plan.color),borderRadius:12,padding:13,fontFamily:"'DM Sans',sans-serif",fontWeight:700,fontSize:14,cursor:"pointer",transition:"all 0.2s" }}>
                {plan.cta}
              </button>
            </div>
          ))}
        </div>
      </section>

      {/* Contact */}
      <section id="contact" style={{ padding:"80px 40px" }}>
        <div style={{ maxWidth:700,margin:"0 auto",textAlign:"center" }}>
          <h2 style={{ fontFamily:"'Syne',sans-serif",fontSize:42,fontWeight:900,marginBottom:14 }}>Get in <span style={{ color:"#00d4aa" }}>Touch</span></h2>
          <p style={{ color:"#9ca3af",fontSize:17,marginBottom:44 }}>Questions? We respond within 30 minutes during business hours.</p>
          <div style={{ display:"flex",gap:16,justifyContent:"center",flexWrap:"wrap" }}>
            {[
              { icon:"📧",label:"Email Us",   value:CONTACT.email,         href:"mailto:"+CONTACT.email },
              { icon:"📞",label:"Call Us",    value:"+91 "+CONTACT.phone,   href:"tel:+91"+CONTACT.phone },
            ].map((c,i) => (
              <a key={i} href={c.href} target={c.href.startsWith("http")?"_blank":undefined} rel="noreferrer" style={{ display:"flex",alignItems:"center",gap:14,background:"#0d0d1f",border:"1px solid #ffffff11",borderRadius:16,padding:"18px 24px",color:"#fff",textDecoration:"none" }}>
                <span style={{ fontSize:28 }}>{c.icon}</span>
                <div style={{ textAlign:"left" }}>
                  <div style={{ fontSize:11,color:"#9ca3af",marginBottom:2 }}>{c.label}</div>
                  <div style={{ fontWeight:600,fontSize:14,color:c.color||"#fff" }}>{c.value}</div>
                </div>
              </a>
            ))}
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer style={{ borderTop:"1px solid #ffffff0d",padding:40,textAlign:"center",color:"#6b7280" }}>
        <div style={{ fontFamily:"'Syne',sans-serif",color:"#00d4aa",fontSize:22,fontWeight:900,marginBottom:10 }}>⚡ LeadBot Pro</div>
        <p style={{ marginBottom:6 }}>AI Lead Generation · Google Maps · JustDial · IndiaMart · Sulekha</p>
        <div style={{ display:"flex",gap:20,justifyContent:"center",flexWrap:"wrap",marginTop:16,marginBottom:16,fontSize:13 }}>
          {[["✅ Free tier available","#00d4aa"],["🤖 AI scoring included","#a855f7"],["📞 Real phone numbers","#60a5fa"],["⚡ Auto-delivery paid plans","#f59e0b"]].map(([t,c],i) => (
            <span key={i} style={{ color:c }}>{t}</span>
          ))}
        </div>
        <p style={{ fontSize:13 }}>© 2026 LeadBot Pro · {CONTACT.email} · +91 {CONTACT.phone}</p>
      </footer>
    </div>
  );
}
